(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6669],{

/***/ 61185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AppRatingModal_AppRatingModal; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/components/GenericModal/GenericModal.module.scss
var GenericModal_module = __webpack_require__(49906);
var GenericModal_module_default = /*#__PURE__*/__webpack_require__.n(GenericModal_module);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./package.json
var package_namespaceObject = {"i8":"4.4.60"};
// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(65885);
// EXTERNAL MODULE: ./src/api/config/index.js + 2 modules
var config = __webpack_require__(65599);
;// CONCATENATED MODULE: ./src/api/ratings.js




var cookies = new es6/* default */.Z();
function postRatings(_x) {
  return _postRatings.apply(this, arguments);
}

function _postRatings() {
  _postRatings = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(body) {
    var authorization, headers, response, rating, _error$response, _error$response$data, _error$response$data$, userMessage;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            authorization = cookies.get('token');
            headers = {
              appId: "kritikos-web",
              authorization: "Bearer ".concat(authorization)
            };
            _context.prev = 2;
            _context.next = 5;
            return config/* wave.post */.t.post('/v2/ratings', body, {
              headers: headers
            });

          case 5:
            response = _context.sent;
            rating = response.data.payload.rating;
            return _context.abrupt("return", {
              rating: rating
            });

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);
            userMessage = ((_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : (_error$response$data$ = _error$response$data.error) === null || _error$response$data$ === void 0 ? void 0 : _error$response$data$.userMessage) || 'Κάτι πήγε στραβά. Παρακαλούμε προσπαθήστε ξανά.';
            return _context.abrupt("return", {
              rating: {},
              error: userMessage
            });

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 10]]);
  }));
  return _postRatings.apply(this, arguments);
}
// EXTERNAL MODULE: ./src/store/loader.js
var loader = __webpack_require__(58766);
// EXTERNAL MODULE: ./src/components/Buttons/Buttons.jsx
var Buttons = __webpack_require__(3805);
// EXTERNAL MODULE: ./src/components/MainLogo/MainLogo.jsx
var MainLogo = __webpack_require__(10625);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./src/components/AppRatingModal/AppRatingModalFormStars.module.scss
var AppRatingModalFormStars_module = __webpack_require__(1514);
var AppRatingModalFormStars_module_default = /*#__PURE__*/__webpack_require__.n(AppRatingModalFormStars_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/AppRatingModal/AppRatingModalFormStars.jsx




function AppRatingModalFormStars(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;
  return (0,toConsumableArray/* default */.Z)(Array(5).keys()).map(function (_, i) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      (0,jsx_runtime.jsx)("button", {
        className: (AppRatingModalFormStars_module_default()).btn,
        onClick: function onClick() {
          return onChange(i + 1);
        },
        children: value > i ? /*#__PURE__*/(0,jsx_runtime.jsx)(ai_index_esm/* AiFillStar */.pHD, {
          className: (AppRatingModalFormStars_module_default()).star
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ai_index_esm/* AiOutlineStar */.y5j, {
          className: (AppRatingModalFormStars_module_default()).star
        })
      }, i)
    );
  });
}
// EXTERNAL MODULE: ./src/components/AppRatingModal/styles.module.scss
var styles_module = __webpack_require__(58589);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/AppRatingModal/AppRatingModalForm.jsx












var LOW_RATING_TEXT = 'Τι θα θέλατε να βελτιώσουμε;';
var HIGH_RATING_TEXT = 'Τι σας άρεσε περισσότερο;';
function AppRatingModal(_ref) {
  var onSuccessfulSubmit = _ref.onSuccessfulSubmit;

  var _useState = (0,react.useState)(''),
      comment = _useState[0],
      setComment = _useState[1];

  var _useState2 = (0,react.useState)(''),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isInputFocused = _useState3[0],
      setIsInputFocused = _useState3[1];

  var _useState4 = (0,react.useState)(''),
      labelText = _useState4[0],
      setLabelText = _useState4[1];

  var _useState5 = (0,react.useState)(0),
      stars = _useState5[0],
      setStars = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isRatingSubmitted = _useState6[0],
      setIsRatingSumbitted = _useState6[1];

  function _onClickSubmit() {
    return _onClickSubmit2.apply(this, arguments);
  }

  function _onClickSubmit2() {
    _onClickSubmit2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _yield$postRatings, error;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loader/* default.addEvent */.Z.addEvent('SENDING_RATING');
              _context.next = 3;
              return postRatings({
                ratee: {
                  model: 'app',
                  client: "web/".concat(package_namespaceObject.i8)
                },
                rating: stars,
                comment: comment,
                saveRatingTimeForUser: true
              });

            case 3:
              _yield$postRatings = _context.sent;
              error = _yield$postRatings.error;

              if (error) {
                setErrorMessage(error);
              } else {
                setIsRatingSumbitted(true);
                onSuccessfulSubmit();
              }

              loader/* default.removeEvent */.Z.removeEvent('SENDING_RATING');

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _onClickSubmit2.apply(this, arguments);
  }

  function onChangeStars(value) {
    setStars(value);
    setLabelText(value > 3 ? HIGH_RATING_TEXT : LOW_RATING_TEXT);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (styles_module_default()).main,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (styles_module_default()).imgContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(MainLogo/* default */.Z, {})
    }), !isRatingSubmitted ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (styles_module_default()).text,
        children: "\u03A0\u03CE\u03C2 \u03AE\u03C4\u03B1\u03BD \u03B7 \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1 \u03C4\u03C9\u03BD \u03B1\u03B3\u03BF\u03C1\u03CE\u03BD \u03C3\u03B1\u03C2;"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (styles_module_default()).smallerText,
        children: "\u0392\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B1\u03C2!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).starsContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AppRatingModalFormStars, {
          value: stars,
          onChange: onChangeStars
        })
      }), Boolean(stars) && /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
        className: (styles_module_default()).textAreaContainer,
        htmlFor: "comment",
        children: [isInputFocused && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (styles_module_default()).labelText,
          children: labelText
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", {
          className: (styles_module_default()).textArea,
          id: "comment",
          name: "comment",
          rows: "1",
          wrap: "soft",
          placeholder: !isInputFocused ? "".concat(labelText, " (\u03C0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03AC)") : '',
          onChange: function onChange(e) {
            return setComment(e.target.value);
          },
          onFocus: function onFocus() {
            return setIsInputFocused(true);
          },
          onBlur: function onBlur() {
            return setIsInputFocused(false);
          }
        })]
      }), errorMessage && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).errorMessage,
        children: errorMessage
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).btnContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* BrandButton */.hG, {
          onClick: _onClickSubmit,
          disabled: !stars,
          children: "\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE"
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (styles_module_default()).text,
        children: "\u0395\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03C0\u03BF\u03BB\u03CD!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (styles_module_default()).smallerTextSpacing,
        children: "\u039C\u03B5 \u03C4\u03B7\u03BD \u03B2\u03BF\u03AE\u03B8\u03B5\u03B9\u03AC \u03C3\u03B1\u03C2 \u03B3\u03B9\u03BD\u03CC\u03BC\u03B1\u03C3\u03C4\u03B5 \u03C3\u03C5\u03BD\u03B5\u03C7\u03CE\u03C2 \u03BA\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03BF\u03B9!"
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./src/components/AppRatingModal/AppRatingModal.jsx








function AppRatingModal_AppRatingModal(_ref) {
  var isModalOpen = _ref.isModalOpen,
      onSuccessfulSubmit = _ref.onSuccessfulSubmit,
      onClose = _ref.onClose;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((lib_default()), {
    className: (styles_module_default()).content,
    overlayClassName: (GenericModal_module_default()).overlay,
    portalClassName: (styles_module_default()).modal,
    isOpen: isModalOpen,
    onRequestClose: onClose,
    contentLabel: "Rating",
    ariaHideApp: false,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((styles_module_default()).header, (GenericModal_module_default()).headerClass),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        type: "button",
        className: (styles_module_default()).closeBtn,
        onClick: onClose,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* IoClose */.bjh, {
          className: (GenericModal_module_default()).closeSymbol
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()([(styles_module_default()).body, 'fullBody']),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).container,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AppRatingModal, {
          onSuccessfulSubmit: onSuccessfulSubmit
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (styles_module_default()).footer
    })]
  });
}

/***/ }),

/***/ 49875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ GenericModal; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60155);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83253);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49906);
/* harmony import */ var _GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







function GenericModal(_ref) {
  var modal = _ref.modal;
  var modalClasses = modal.isFullscreen ? {
    base: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().fullScreen), (_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().animatedModal), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, modal.contentClass, modal.contentClass)),
    afterOpen: (_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["animatedModal--after-open"]),
    beforeClose: (_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["animatedModal--before-close"])
  } : classnames__WEBPACK_IMPORTED_MODULE_0___default()((0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, modal.contentClass, modal.contentClass));
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((react_modal__WEBPACK_IMPORTED_MODULE_1___default()), {
    isOpen: modal.isOpen,
    onAfterOpen: modal.afterOpenModal,
    onRequestClose: modal.closeModal,
    style: modal.customStyles,
    contentLabel: modal.label,
    portalClassName: (_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().modal),
    overlayClassName: classnames__WEBPACK_IMPORTED_MODULE_0___default()((0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, modal.overlayClass, modal.overlayClass))
    /* if you are using React 16, the close transition works only if
    you use the isOpen prop to toggle the visibility of the modal. */
    ,
    closeTimeoutMS: modal.isFullscreen ? 400 : 0,
    className: modalClasses,
    ariaHideApp: false,
    children: [modal.closeModal && modal.navigation.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().header), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, modal.headerClass, modal.headerClass)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        children: modal.navigation.map(function (nav) {
          return nav;
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
        type: "button",
        className: (_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().close),
        onClick: function onClick() {
          return modal.closeModal();
        },
        children: modal.icon ? modal.icon : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_5__/* .IoClose */ .bjh, {
          className: (_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().closeSymbol)
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().body), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[modal.bodyOverwrite], modal.bodyOverwrite)),
      children: modal.body[modal.view]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().footer)
    })]
  });
}

/***/ }),

/***/ 7133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P8": function() { return /* binding */ CouponDiscount; },
  "KM": function() { return /* binding */ Order; },
  "ZA": function() { return /* binding */ OrderFromHistory; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/BehaviorSubject.js + 3 modules
var BehaviorSubject = __webpack_require__(20090);
// EXTERNAL MODULE: ./src/utils/json-storage.js
var json_storage = __webpack_require__(19022);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/distinctUntilChanged.js
var distinctUntilChanged = __webpack_require__(41931);
;// CONCATENATED MODULE: ./src/utils/store.js


function emitOnAttrChange(subject, key) {
  return subject.pipe((0,distinctUntilChanged/* distinctUntilChanged */.x)(function (prev, curr) {
    return get_default()(prev, key) === get_default()(curr, key);
  }));
}
;// CONCATENATED MODULE: ./src/store/order.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var couponSubject = new BehaviorSubject/* BehaviorSubject */.X(0);
var INITIAL_SUBJECT_VALUE = undefined;
var STORAGE_NAME_ORDER = 'order';
var STORAGE_NAME_ORDER_HISTORY = 'prevOrder';
var meta = {
  cached: false,
  fetched: false,
  updatedAt: new Date()
};
var metaOrderFromHistory = {
  cached: false,
  fetched: false,
  updatedAt: new Date()
};
var Order = {
  subject: new BehaviorSubject/* BehaviorSubject */.X(null),
  lazyInit: function lazyInit() {
    if (Order.subject.value !== null) return Order.subject;
    var storage = window.localStorage;
    var order = json_storage/* default.get */.ZP.get(STORAGE_NAME_ORDER, {
      storage: storage
    });
    Object.assign(meta, {
      cached: true,
      fetched: false,
      updatedAt: new Date()
    });
    Order.subject = new BehaviorSubject/* BehaviorSubject */.X(order);
    return Order.subject;
  },
  update: function update(order) {
    var order$ = Order.lazyInit();
    var storage = window.localStorage;
    json_storage/* default.set */.ZP.set(STORAGE_NAME_ORDER, order, {
      storage: storage
    });
    order$.next(order);
    Object.assign(meta, {
      fetched: true,
      updatedAt: new Date()
    });
  },
  subscribe: function subscribe(setState) {
    var order = Order.lazyInit();
    return order.subscribe(setState);
  },
  getValue: function getValue() {
    var order = Order.lazyInit();
    return order.value;
  },
  getService$: function getService$() {
    var order = Order.lazyInit();
    return emitOnAttrChange(order, 'selectedService');
  },
  setSelectedAddress: function setSelectedAddress(addressObject) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      addressObject: addressObject
    }));
  },
  setTimeslot: function setTimeslot(slot) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      timeSlotEnd: slot.timeSlotEnd,
      timeSlotStart: slot.timeSlotStart,
      timeslotId: slot._id ? slot._id : null
    }));
  },
  getTimeSlotStart: function getTimeSlotStart() {
    var order = Order.getValue();
    return order.timeSlotStart;
  },
  setChangesAllowed: function setChangesAllowed(option) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      changesAllowed: option
    }));
  },
  setPointsUse: function setPointsUse(usePoints) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      redeemPoints: usePoints
    }));
  },
  setPlasticBags: function setPlasticBags(wantPlasticBags) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      wantPlasticBags: wantPlasticBags
    }));
  },
  setInvoiceInfo: function setInvoiceInfo(invoiceInfo) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      invoice: {
        companyAddress: invoiceInfo.companyAddress,
        companyName: invoiceInfo.companyName,
        companyPhone: invoiceInfo.companyPhone,
        profession: invoiceInfo.profession,
        taxId: invoiceInfo.AFM,
        taxOffice: invoiceInfo.DOY
      }
    }));
  },
  setCouponCode: function setCouponCode(code) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      couponCode: code
    }));
  },
  setPaymentType: function setPaymentType(paymentType, datacashReference) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      paymentType: paymentType,
      datacashReference: datacashReference
    }));
  },
  setProducts: function setProducts(products) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      products: products
    }));
  },
  setComments: function setComments(comments) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      comments: comments
    }));
  },
  setOffers: function setOffers(offers) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      offers: offers
    }));
  },
  setShopId: function setShopId(shop) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      shop: shop
    }));
  },
  setPenalty: function setPenalty(penaltyFee, minimumPrice) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      penaltyFee: penaltyFee,
      minimumPrice: minimumPrice
    }));
  },
  setDiscountCampaignsApplied: function setDiscountCampaignsApplied(discountCampaignsApplied) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      discountCampaignsApplied: discountCampaignsApplied
    }));
  },
  setTotalPrice: function setTotalPrice(totalPrice) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      totalPrice: totalPrice
    }));
  },
  reset: function reset() {
    Order.update(undefined);
  },
  deleteProperty: function deleteProperty(properties) {
    var order = Order.getValue();
    var newOrder = properties.reduce(function (acc, property) {
      return _objectSpread(_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, property, null));
    }, order);
    Order.update(newOrder);
  }
};
var CouponDiscount = {
  update: function update(code) {
    couponSubject.next(code);
  },
  subscribe: function subscribe(setState) {
    return couponSubject.subscribe(setState);
  },
  getValue: function getValue() {
    return couponSubject.value;
  }
};
var OrderFromHistory = {
  subject: INITIAL_SUBJECT_VALUE,
  lazyInit: function lazyInit() {
    if (OrderFromHistory.subject) return OrderFromHistory.subject;
    var storage = window.localStorage;
    var orderFromHistory = json_storage/* default.get */.ZP.get(STORAGE_NAME_ORDER_HISTORY, {
      storage: storage
    });
    Object.assign(metaOrderFromHistory, {
      cached: true,
      fetched: false,
      updatedAt: new Date()
    });
    OrderFromHistory.subject = new BehaviorSubject/* BehaviorSubject */.X(orderFromHistory);
    return OrderFromHistory.subject;
  },
  subscribe: function subscribe(setState) {
    var orderFromHistory = OrderFromHistory.lazyInit();
    return orderFromHistory.subscribe(setState);
  },
  update: function update(order) {
    var orderFromHistory$ = OrderFromHistory.lazyInit();
    orderFromHistory$.next(order);
    Object.assign(metaOrderFromHistory, {
      fetched: true,
      updatedAt: new Date()
    });
    var storage = window.localStorage;
    json_storage/* default.set */.ZP.set(STORAGE_NAME_ORDER_HISTORY, order, {
      storage: storage
    });
  },
  getValue: function getValue() {
    var orderFromHistory = OrderFromHistory.lazyInit();
    return orderFromHistory.value;
  }
};
/* harmony default export */ var order = ({
  Order: Order,
  CouponDiscount: CouponDiscount,
  OrderFromHistory: OrderFromHistory
});

/***/ }),

/***/ 13764:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var CUSTOM_STYLES = {
  overlay: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9,
    backgroundColor: 'rgba(0, 0, 0, 0.3)'
  },
  content: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate3d(-50%, -50%, 0)',
    padding: 0,
    right: 'unset',
    bottom: 'unset'
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (CUSTOM_STYLES);

/***/ }),

/***/ 1514:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"AppRatingModalFormStars_btn__54_s0","star":"AppRatingModalFormStars_star__ejFlZ"};

/***/ }),

/***/ 58589:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__U0m7Q","header":"styles_header__8Ze7U","closeBtn":"styles_closeBtn__L2_TE","container":"styles_container__6Y0Xj","imgContainer":"styles_imgContainer___ddhq","text":"styles_text__KpH5i","smallerText":"styles_smallerText__LCA5d","smallerTextSpacing":"styles_smallerTextSpacing__PqqND","starsContainer":"styles_starsContainer__yXFcg","labelText":"styles_labelText__znIV4","textArea":"styles_textArea__5xbyv","btnContainer":"styles_btnContainer__RfEq_","errorMessage":"styles_errorMessage__C_Qpe"};

/***/ }),

/***/ 49906:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"GenericModal_overlay__7Yioc","content":"GenericModal_content__SA2Cs","header":"GenericModal_header__UAPNk","close":"GenericModal_close__NUvg3","body":"GenericModal_body__30vFq","closeSymbol":"GenericModal_closeSymbol__HXyFa","orderStatusBody":"GenericModal_orderStatusBody__Ku4ow","productOptionsViewBody":"GenericModal_productOptionsViewBody__VSHpb","productOptionsHeader":"GenericModal_productOptionsHeader__VQkt5","fullBody":"GenericModal_fullBody__XJgFq","takeAwayBody":"GenericModal_takeAwayBody__L1xDW","fullScreen":"GenericModal_fullScreen__2CJna","animatedModal":"GenericModal_animatedModal__cwNF7","animatedModal--after-open":"GenericModal_animatedModal--after-open__7BhKM","animatedModal--before-close":"GenericModal_animatedModal--before-close__rXjpG"};

/***/ })

}]);